import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";

const EfisModal = ({
  show,
  title,
  body,
  children,
  primaryLabel,
  secondaryLabel,
  loadingConfirmationAction,
  closeHandler,
  confirmationHandler,
  size,
  primaryLabelVisible = true,
  colorVariant,
}) => (
  <Modal scrollable show={show} size={size} onHide={() => closeHandler()} backdrop="static" keyboard={false}>
    <Modal.Header closeButton>
      <Modal.Title>{title || "Tem certeza disso?"}</Modal.Title>
    </Modal.Header>

    <Modal.Body>
      {typeof body === "string" ? <p>{body}</p> : body}
      {children}
    </Modal.Body>

    <Modal.Footer>
      {loadingConfirmationAction ? (
        <Spinner animation="border" role="status" />
      ) : (
        primaryLabelVisible && (
          <Button
            variant="primary"
            onClick={() => {
              confirmationHandler();
            }}
          >
            {primaryLabel || "Confirmar"}
          </Button>
        )
      )}
      <Button variant={colorVariant || "light"} onClick={() => closeHandler()}>
        {secondaryLabel || "Cancelar"}
      </Button>
    </Modal.Footer>
  </Modal>
);

export default EfisModal;
